import React from 'react';
import { Users, BookCopy, Star, Globe } from 'lucide-react';
export function SocialProofBar() {
  return <div className="bg-emerald-950/40 text-emerald-100 py-2.5 px-3 border-y border-emerald-800/40 relative z-20" data-id="element-228">
      <div className="max-w-4xl mx-auto flex flex-wrap justify-center items-center gap-x-4 gap-y-1 text-[10px] md:text-xs font-bold text-center uppercase tracking-wide" data-id="element-229">
        <div className="flex items-center" data-id="element-230">
          <Users className="w-3 h-3 md:w-4 md:h-4 mr-1 text-emerald-400" data-id="element-231" />
          <span data-id="element-232">+5.000 docentes confían</span>
        </div>
        <span className="hidden md:inline opacity-30" data-id="element-233">|</span>
        <div className="flex items-center" data-id="element-234">
          <BookCopy className="w-3 h-3 md:w-4 md:h-4 mr-1 text-emerald-400" data-id="element-235" />
          <span data-id="element-236">6 tomos premium</span>
        </div>
        <span className="hidden md:inline opacity-30" data-id="element-237">|</span>
        <div className="flex items-center" data-id="element-238">
          <Star className="w-3 h-3 md:w-4 md:h-4 mr-1 fill-current text-emerald-400" data-id="element-239" />
          <span data-id="element-240">4,9/5 calificación</span>
        </div>
        <span className="hidden md:inline opacity-30" data-id="element-241">|</span>
        <div className="flex items-center" data-id="element-242">
          <Globe className="w-3 h-3 md:w-4 md:h-4 mr-1 text-emerald-400" data-id="element-243" />
          <span data-id="element-244">Todo el mundo hispanohablante</span>
        </div>
      </div>
    </div>;
}